import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import './_button.scss'

const Button = ({ 
  children, 
  href, 
  to, 
  className, 
  target = '_blank', 
  onClick = () => {}, 
  disabled, 
  theme, 
  type = 'button', 
  loading, 
  testId, 
  form 
}) => {
  const renderClasses = () => {
    const classes = ['button'];
    if (disabled) classes.push('button--disabled');
    if (theme) classes.push(`button--${theme}`);
    if (loading) classes.push('button--loading');
    if (loading && !disabled) classes.push('button--disabled');
    if (className) classes.push(className);

    return classes.join(' ');
  }

  const formAttribute = Array.isArray(form) ? form.join(' ') : form;

  const commonProps = {
    className: renderClasses(),
    disabled: disabled || loading,
    'data-testid': testId,
    onClick
  }

  if (href) {
    return <a {...commonProps} href={href} target={target}>{children}</a>
  } else if (to) {
    return <Link {...commonProps} to={to} target={target}>{children}</Link>
  } else {
    return <button type={type} {...commonProps} form={formAttribute}>{children}</button>
  }
}


Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(['outline', 'danger']),
  type: PropTypes.oneOf(['submit', 'button']),
  loading: PropTypes.bool,
  href: PropTypes.string,
  to: PropTypes.string,
  className: PropTypes.string,
  target: PropTypes.string,
  disabled: PropTypes.bool,
  testId: PropTypes.string,
  form: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
}

export default Button
